var map = {
	"./bedford.svg": 69113,
	"./broxbourne.svg": 4007,
	"./darlington.svg": 35641,
	"./demo.svg": 84724,
	"./hull.svg": 99448,
	"./kirklees.svg": 66685,
	"./leicester.svg": 52049,
	"./northgate.svg": 46347,
	"./preston.svg": 60550,
	"./rushcliffe.svg": 5836,
	"./slough.svg": 65029
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66425;